import React from 'react';

const partners = [
  {
    name: 'AliExpress',
    logo: 'https://static.vecteezy.com/system/resources/thumbnails/054/650/803/small_2x/aliexpress-logo-rounded-aliexpress-logo-free-png.png',
  },
];

const Partners = () => {
  return (
    <section className="bg-gray-50 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        {/* <p className="text-sm font-semibold uppercase tracking-[0.18em] text-green-700 mb-3">
          Our Partners
        </p> */}

        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
         Our Partners
        </h2>

        {/* <p className="text-gray-600 max-w-3xl mx-auto mb-10">
          KambiHome works with trusted commerce and supply partners to connect
          customers with products from across global markets.
        </p> */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="bg-white rounded-xl shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-300 p-6 h-full min-h-[180px] flex flex-col items-center justify-center cursor-pointer"
            >
              <div className="w-full h-24 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="max-h-24 max-w-[200px] w-auto object-contain"
                  loading="lazy"
                />
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mt-4">
                {partner.name}
              </h3>
            </div>
          ))}

          <div className="bg-white/70 rounded-xl border border-dashed border-gray-200 p-6 min-h-[180px] flex flex-col items-center justify-center">
            <span className="text-sm font-semibold text-gray-400">
              More Partners
            </span>

            <p className="text-xs text-gray-400 mt-2">
              Coming soon
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;